/* eslint-disable require-await */
import axios from "axios";

const apiClient = axios.create({
    baseURL: "",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    }
});

apiClient.interceptors.response.use(
    response => response,
    async error => {
        if (
            error.response?.status === 401 ||
            error.response?.data?.message === "Unauthenticated."
        ) {
            console.warn("Token expired. Redirecting to login...");

            window.location.href = route("login");
        }

        return Promise.reject(error);
    }
);

export { apiClient };
